
import { computed, defineComponent, reactive, ref, watch, onBeforeMount, useAttrs } from 'vue';
import { EditOutlined } from '@ant-design/icons-vue'
import { OemModule } from '@/store/modules/oem.module';
import { ProviderModule } from '@/store/modules/provider.module';
import OpenOtherApi from '@/api/OpenOtherApi';
import { RuleObject } from 'ant-design-vue/lib/form';
import { verifyUrl } from '@/utils/verify.util';

export default defineComponent({
  components: {
    EditOutlined
  },
  props: {
    type: {
      type: String
    },
    description: {
      type: String
    },
    learnMoreUrl: {
      type: String
    }
  },
  setup (props) {
    const attrs = useAttrs()
    const oemConfig = computed(() => OemModule.config)
    const providerName = computed(() => ProviderModule.providerName)
    const user = computed(() => ProviderModule.user)
    const show = ref(false)
    const showLearnMore = reactive({
      description: props.description || '',
      learnMoreUrl: props.learnMoreUrl || ''
    })
    const formRef = ref()
    const editModel = ref({
      description: '',
      learnMoreUrl: ''
    })
    const visible = ref(false)

    const checkUrl = async (rule: RuleObject, value: string) => {
      if (!verifyUrl(value)) {
        return Promise.reject('请输入正确的链接')
      }
      return Promise.resolve()
    }
    const rules = {
      description: [
        { required: true, message: '请输入描述文字', trigger: 'blur' }
      ],
      learnMoreUrl: [
        { validator: checkUrl, trigger: 'blur' },
        { required: true, message: '请输入了解更多链接', trigger: 'blur' }
      ]
    }

    function generateUrl (url: string) {
      if (url.indexOf("http://") >= 0 || url.indexOf("https://") >= 0) {
        return url
      }
      return "http://" + url
    }

    function init () {
      if (oemConfig.value.open) {
        if (oemConfig.value.learnMore === 'each' && props.type) {
          OpenOtherApi.getOemHelpdocUrl(props.type).then(res => {
            if (res.description) {
              showLearnMore.description = res.description;
            } else {
              showLearnMore.description = showLearnMore.description.replace(/易维帮助台/g, providerName.value)
            }
            if (res.learnMoreUrl) {
              showLearnMore.learnMoreUrl = generateUrl(res.learnMoreUrl);
            }
            editModel.value.description = showLearnMore.description
            editModel.value.learnMoreUrl = showLearnMore.learnMoreUrl
          })
        } else if (oemConfig.value.learnMore === 'one') {
          showLearnMore.description = showLearnMore.description.replace(/易维帮助台/g, providerName.value);
          showLearnMore.learnMoreUrl = generateUrl(oemConfig.value.learnMoreUrl)
          show.value = true
        }
      } else {
        showLearnMore.description = showLearnMore.description.replace(/易维帮助台/g, providerName.value);
        show.value = true
      }
    }

    watch(
      () => providerName.value,
      (n) => {
        if (n) {
          showLearnMore.description = showLearnMore.description.replace(/易维帮助台/g, n);
        }
      }
    )

    function handleEditConfig () {
      visible.value = true
    }

    function handleSaveConfig () {
      formRef.value.validate().then(() => {
        OpenOtherApi.saveOemHelpdocUrl(editModel.value)
        .then(() => {
          showLearnMore.description = editModel.value.description;
          showLearnMore.learnMoreUrl = generateUrl(editModel.value.learnMoreUrl)
          visible.value = false
        })
      })
    }

    onBeforeMount(() => {
      init()
    }) 

    return {
      attrs,
      oemConfig,
      user,
      show,
      showLearnMore,
      formRef,
      editModel,
      visible,
      rules,
      handleEditConfig,
      handleSaveConfig
    }
  }
})
